import { SlateNode } from '@all-hands-hq/plex-graphql-schema';
import { Node } from 'slate';

export const slateNodesToString = (nodes: SlateNode[]): string => {
  // TODO(https://github.com/all-hands-hq/source/issues/1046)
  return nodes.map((n) => Node.string(n as Node)).join('\n');
};
